export const CONTENT_ENDPOINTS = {
    LIST: "/InfluencersContent/List",
    CREATE: "/InfluencersContent/Create",
    UPDATE: (id) => `/InfluencersContent/Update/${id}`,
    DELETE: (id) => `/InfluencersContent/Delete/${id}`,
    UPLOAD_MEDIA: "/InfluencersContent/UploadMedia",
    UPLOAD_VIDEO: "/InfluencersContent/UploadVideo",
    DELETE_MEDIA: (cloudflareId) => `/InfluencersContent/DeleteMedia/${cloudflareId}`,
    SEND_CHAT_MESSAGE: "/InfluencersContent/SendMessageToRepressentative",
};
